import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What writing a book feels like",
  "description": "",
  "published": "2012-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/what-writing-a-book-is-like/swizec/5550"],
  "categories": "Recreation, Roller coaster, Uncategorized, Writers Resources, Writing",
  "hero": "./img/tumblr_mdft49yjX41qekjngo1_500.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`When I set out to write `}<a parentName="p" {...{
        "href": "https://leanpub.com/nightowls"
      }}>{`Why programmers work at night`}</a>{` I knew it wasn't going to be a walk in the park, but hey, I've got plenty of writing experience. How hard can it be?`}</p>
    <p>{`So far I've written 895 posts on this blog, `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-year-of-750words-com-with-shiny-graphs/swizec/4378"
      }}>{`written morning words`}</a>{` on 561 consecutive days amounting to just shy of 460,000 words. If that was a novel it would make the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/List_of_longest_novels",
        "title": "List of longest novels"
      }}>{`list of longest novels`}</a>{`. Clearly I am well prepared!`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/11/swizec-750words-stats.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/11/swizec-750words-stats.png",
          "alt": "My 750words stats",
          "title": "My 750words stats"
        }}></img></a></p>
    <p>{`I had `}<strong parentName="p"><em parentName="strong">{`no idea`}</em></strong>{`.`}</p>
    <p>{`Man, books are `}<em parentName="p">{`hard`}</em>{`.`}</p>
    <p>{`Screw startups, launching small businesses and fun web projects. Writing a book is the most mind bending experience you can have, with the possible exception of having sex for the first time. Startups are an emotional roller coaster, very tough on the psyche - writing a book isn't even a roller coaster.`}</p>
    <p>{`It's `}<a parentName="p" {...{
        "href": "http://paulgraham.com/schlep.html"
      }}>{`schlep work`}</a>{` through and through.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/061af4e40438845af8bda1b5225b6bdc/41099/tumblr_mdft49yjX41qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20200v200h401V0h-26c-21%200-25%200-24%201a620%20620%200%200016%2015l2%204%208%2012%2013%2023c2%201%204%206%205%2010l4%208%201%209v7l-3-8-3-9-3-8c-3-9-5-10-16-20-6-5-6-5-4%201a192%20192%200%200112%2032c1%204%202%205%203%205l2%201%203%201%202%202%205%207a642%20642%200%20010%2096l-1%204v-3l-3-3c-2%200-4-2-4-4s0-2%202-2c4%202%204%203%204-13%200-7%200-8%202-8%203%200%200-3-3-5a10780%2010780%200%2000-15-5l-4-4%205%202%204%202v-8l1-4c-1-3%200-5%202-3%201%203%203-1%203-5l-2-7c-3-27-13-63-17-65l-13-5-4-1-10-3-12-4c-3-2-4-2-7-1l-11-1-19-1-24-3a490%20490%200%2000-92-9c5%200%205-2%200-2l-5-1h14l-7-1-6-1h7c3%200%206%200%205-1l-2-6-1-6-1-1c0-2%203%200%203%202s1%203%203%203c1%200%202%201%202%204v1c1-6%2011-6%2048-2l12%201c-10-3-1-2%2012%200l14%202-5-18-1-4H0v200m150-91h-6v22l-1%2041v20h26l68-1h43v-20l-6-60c-2-2-99-4-124-2m147%2015c-2%201%201%205%203%206%202%200%203%202%204%205%202%206%203%207%203%203%200-7%206-9%2010-5%202%202%202%203%200%207-2%203-2%204%200%204%203%202%206%201%206%200%200-2%201-2%203-2%2010%200%2012-3%208-11-2-5-3-5-21-6a73%2073%200%2001-16-1m52%2016a293%20293%200%20002%2046l1-13%201-13c2-2%202-4%201-7-2-3-2-3%200-4l1-4c-1-4-5-7-6-5M91%20158h-7c-9%201-9%203-1%203%204%200%205%200%203%201h-4l-2%201-1%201c-1-2-4%202-3%204%200%202%200%202%201%200l3-3c5%200%2016-2%2015-3l-1-1%202-2c0-2-3-3-5-1m215%201v2l1%205c0%203%200%203-2%203h-2l2%203c0%202%202%203%202%201h2c2%202%202%202%200%202s-2%200%201%202%2014%202%2014%200l1-2%201%202v4l1%201v3h1c0-2%200-2%201%200%203%202%204%200%201-3-1-2-1-2%202-5l2-3c-2%200-3-1-1-3v-2c-1-1-1-1-2%201l-2%202v-5l-3%201-1%202-2%201-2%201c0%202-5-2-10-8l-5-5M76%20188l-1%205c-1%201%200%201%201%201%208%200%208-1%208%208v9h3c2%201%202%201%202-4l-2-10c-1-5-1-5-5-5-3%200-3%200-3-4l-1-4c-2%200-2%201-2%204m265%203l2%201v1h-5c-2%203-12%204-31%204-17%200-18%200-16%202l6%201%202%202%203%201%201%202-1%202h-4l-6-1-4%201v3c0%203%200%203-1%202l-2-4a2501%202501%200%2001-130%202l-5%201h4c4%200%204%200%202%202-2%201-2%201%204%201h3c-4%200-2%203%202%203%202%200%203%200%202%201%200%201%201%202%202%201%204%200%2011%201%209%202-3%201-1%201%2018%201%2014%200%2014%200%2014%202%201%202%201%202%2016%202%2016%200%2017%200%2017-2-1-2%203-2%2016-2a181%20181%200%200021%200c0%201-5%202-11%201-4%200-5%200-4%201h-1c-4-1-14%201-13%203%200%201%205%201%2055-1%2021-1%2024-1%2024%202a25173%2025173%200%2001-151%209c-1%201-9%203-12%202l-2%201a1621%201621%200%2000169-5l-3-1c-3-1-3-1%201-1l4%201c0%201%206%201%2025-1%2013-1%2015-2%2011-2-4-1-6-4-3-4l1-1h-6l-4-1%204-1c4%200%205%200%204-2%200-2%200-2%202-2s2-1%201-3l-13-1h-9c1-1%201-1-1-1l-4%201h-3l-7-2c-7%200-10-1-10-5%200-2%201-2%206-2l6-1%202-1c2%200%202%200%201-1-1-2%200-4%203-4%202%200%201-1-1-1l-3-1h3l4%201%201%201%202-8c1-2-6-2-7-1m-81%20108c-4%200-4%201-2%201l3%202v3c2%203%202%204-2%204-2%200-2%200-2%202l1%203%205%201c5%200%205%200%205-3l-3-4c-1-1-1-1%201-1s3%201%204%204l3%203%202%201c0%204%203%207%206%207%205%200%207-1%205-3l-1-3-1-2-1-1%204-1c6%200%207-1%206-4s-3-3-13-1l-2-1c-1-1%201-1%203-1%208%200%2010-1%209-4-2-3-4-3-14-1-5%200-5%203-1%206l3%201h-3a345%20345%200%2001-5-1v-3c0-2-1-2-3-2-4%201-5%200-3-1%203-1%200-2-4-1m-45%206c-3%200-3%201-3%203s1%203%204%203l4%201-1%203c0%202%201%203%206%203s6-1%204-5c-1-2-2-2-4-1-3%200-3%200-3-2l-1-4c0-2-1-2-6-1m33%205l-3%201v3c0%202%201%202%206%202%204%200%205%200%203%201-3%200-3%201-3%204l1%203c1%202%208%201%209%200%202-1-1-7-3-7l-3-6c-1-2-3-2-7-1m-134%203l2%201%202%201c2%200%202%200%200%201l7%201h11c2-3%201-4-7-4h-15m123%206h-4l1%204%202%204%207-1c6%200%206%200%206-3l-1-4h-11m-8%200a621%20621%200%2001-63%203v7h13l33-1h20v-4l-3-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/061af4e40438845af8bda1b5225b6bdc/ca0a1/tumblr_mdft49yjX41qekjngo1_500.webp 223w", "/static/061af4e40438845af8bda1b5225b6bdc/75680/tumblr_mdft49yjX41qekjngo1_500.webp 445w", "/static/061af4e40438845af8bda1b5225b6bdc/b0a15/tumblr_mdft49yjX41qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/061af4e40438845af8bda1b5225b6bdc/853b2/tumblr_mdft49yjX41qekjngo1_500.jpg 223w", "/static/061af4e40438845af8bda1b5225b6bdc/0a4fe/tumblr_mdft49yjX41qekjngo1_500.jpg 445w", "/static/061af4e40438845af8bda1b5225b6bdc/41099/tumblr_mdft49yjX41qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/061af4e40438845af8bda1b5225b6bdc/41099/tumblr_mdft49yjX41qekjngo1_500.jpg",
                "alt": "My book is taunting me to write moar.",
                "title": "My book is taunting me to write moar.",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`My book is taunting me to write moar.`}</figcaption>{`
  `}</figure></p>
    <p>{`Most of the time you have no idea what you're trying to say, but you have to say it coherently. It's as if your thoughts on the subject are being revealed to you `}<em parentName="p">{`while`}</em>{` you write. The moment you're done with a subchapter you immediately need to rewrite it because now you know what you were trying to say and the initial paragraphs are all wrong.`}</p>
    <p>{`Sure, you're not supposed to edit while writing, but this isn't editing. This is refining a mind dump into a first draft.`}</p>
    <p>{`There's also a special kind of flow to the whole thing. Coding flow is easy, it's something I can go into almost instantly. But writing flow ... that takes time. And unlike coding flow, this one can't be paused. If you pause your flow, your writing will feel different when you get back. Readers will notice a break in the flow.`}</p>
    <p>{`Very jarring.`}</p>
    <p>{`So you do things like that `}{`*`}{`points at previous line`}{`*`}{` to make it seem intentional :)`}</p>
    <p>{`At the end of the day, you feel great! Finally managed to have a whole day for writing, It was awesome. Marvellous Ecstatic! You got plenty done and the book is almost ready to have its first Minimum Viable Book version unleashed on the world.`}</p>
    <p>{`You look at the time tracker - 4 hours. Just four actual hours spent writing. Because writing isn't coding and it's almost impossible to keep focused for more than an hour at time. Haven't built the stamina yet.`}</p>
    <p>{`But you're getting somewhere anyway. The chapter you've spent two weeks working on, tens of hours, is finally shaping up.`}</p>
    <p>{`Reading time 00:14:50.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://victoria-writes.com/2012/11/09/learning-lessons-from-other-writers/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/124522299_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://victoria-writes.com/2012/11/09/learning-lessons-from-other-writers/"
        }}>{`Learning lessons from other writers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lyricfire.typepad.com/lyric-fire/2012/11/why-ride-roller-coasters-when-writing-gives-you-the-same-thrills-novel-update.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/125023936_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://lyricfire.typepad.com/lyric-fire/2012/11/why-ride-roller-coasters-when-writing-gives-you-the-same-thrills-novel-update.html"
        }}>{`Why Ride Roller Coasters When Writing Gives You The Same Thrills? - (Novel Update!)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jaxibella.wordpress.com/2012/11/12/sometimes-im-a-bad-blogger-and-here-are-some-excuses-for-why/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/125156340_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://jaxibella.wordpress.com/2012/11/12/sometimes-im-a-bad-blogger-and-here-are-some-excuses-for-why/"
        }}>{`Sometimes I'm A Bad Blogger (And Here Are Some Excuses For Why)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://weburbanist.com/2012/10/22/looping-roller-coaster-stairway-you-can-actually-walk-on/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/120534342_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://weburbanist.com/2012/10/22/looping-roller-coaster-stairway-you-can-actually-walk-on/"
        }}>{`Looping Roller-Coaster Stairway You Can Actually Walk On`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://writingpiecesofme.wordpress.com/2012/11/12/what-am-i-writing/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/125253758_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://writingpiecesofme.wordpress.com/2012/11/12/what-am-i-writing/"
        }}>{`What am I Writing?`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=716400e8-0a82-4a45-817d-48620ab9d74c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      